import { AppState } from '../reducers';
import { DocumentState } from '../reducers/document_reducer';

export const selectDocumentState = (state: AppState): DocumentState => 
    state.documents;
